import { Component, HostListener, inject, OnInit } from "@angular/core";
import { PrimeNGConfig } from "primeng/api";
import localePL from "@angular/common/locales/pl";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import "dayjs/locale/pl";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { registerLocaleData } from "@angular/common";
import { ToastModule } from "primeng/toast";
import { filter } from "rxjs";
import { GoogleTagManagerService, isCreatorUrl } from "./shared/data/services/google-tag-manager.service";
import { MaintenanceWatchService } from "./shared/services/maintenance/maintenance-watch.service";
import { WEEKDAY_SHORT_PL } from "./shared/utils/weekday-names";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: true,
  providers: [],
  imports: [RouterOutlet, ToastModule],
})
export class AppComponent implements OnInit {
  title = "Przechowalnia24 - Panel rezerwacji";
  isPanel = false;

  private readonly router = inject(Router);
  private readonly gtm = inject(GoogleTagManagerService);
  private readonly maintenanceWatch = inject(MaintenanceWatchService);

  constructor(private config: PrimeNGConfig) {
    registerLocaleData(localePL, "pl-PL");
    dayjs.extend(advancedFormat);
    dayjs.locale("pl");
  }

  ngOnInit(): void {
    // Przerwa techniczna / nowe wdrożenie w otwartej karcie → przeładowanie.
    this.maintenanceWatch.start();

    // Wirtualne page-views dla SPA. NavigationEnd emituje po każdej zmianie
    // trasy Angular Router; GTM w kontenerze zamienia to zdarzenie na hit
    // `page_view` do GA4 (mapowanie po nazwie zdarzenia w konfiguracji GTM).
    // Tylko kreator – panel, logowanie i reset hasła działają bez GTM.
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        filter((event) => isCreatorUrl(event.urlAfterRedirects)),
      )
      .subscribe((event) => {
        this.gtm.pushPageView(event.urlAfterRedirects);
      });

    this.config.setTranslation({
      accept: "Akceptuj",
      addRule: "Dodaj regułę",
      apply: "Zastosuj",
      before: "Przed",
      cancel: "Anuluj",
      choose: "Wybierz",
      clear: "Wyczyść",
      contains: "Zawiera",
      // 3-literowe skróty w całym panelu (kreator ma własne tłumaczenie).
      dayNamesMin: [...WEEKDAY_SHORT_PL],
      dateAfter: "Data po",
      dateBefore: "Data przed",
      dateFormat: "dd.mm.yy",
      dateIs: "Data jest",
      dateIsNot: "Data nie jest",
      endsWith: "Kończy się na",
      equals: "Równa się",
      firstDayOfWeek: 1,
      gt: "Większe niż",
      gte: "Większe lub równe",
      lt: "Mniejsze niż",
      lte: "Mniejsze lub równe",
      monthNames: [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień",
      ],
      monthNamesShort: [
        "Sty",
        "Lut",
        "Mar",
        "Kwi",
        "Maj",
        "Cze",
        "Lip",
        "Sie",
        "Wrz",
        "Paź",
        "Lis",
        "Gru",
      ],
      matchAll: "Dopasuj wszystkie",
      matchAny: "Dopasuj którekolwiek",
      notContains: "Nie zawiera",
      notEquals: "Nie równa się",
      reject: "Odrzuć",
      removeRule: "Usuń regułę",
      startsWith: "Zaczyna się od",
      today: "Dzisiaj",
      weekHeader: "Tydz",
    });
  }

  @HostListener("window:onbeforeunload", ["$event"])
  closeApp(): void {
    // sessionStorage.clear();
  }
}
